import service from "./request"

const server = {
    // 获取支付结果
    getPayStatus:(data)=>{
        return service.request("/battswap/app/order/isPay","post",data)
    },
    // nicepay 支付回调
    getNicepay:(data)=>{
        return service.request("/battswap/app/order/webhook/nicepay","post",data)
    },
    // 套餐列表
    getServiceList:(data)=>{
        return service.request("/battswap/app/service/list","post",data)
    },
    // 套餐详情
    getServiceInfo:(data)=>{
        return service.request("/battswap/app/service/info","post",data)
    },
    // 开通套餐
    openService:(data)=>{
        return service.request("/battswap/app/service/open","post",data)
    },
    // 变更套餐
    editService:(data)=>{
        return service.request("/battswap/app/service/edit","post",data)
    },
    // 关闭套餐
    closeService:(data)=>{
        return service.request("/battswap/app/service/close","post",data)
    },
    // 套餐开通记录列表
    getServiceOpenList:(data)=>{
        return service.request("/battswap/app/service/openlog/list","post",data)
    },
    // 套餐开通记录详情
    getServiceOpeninfo:(data)=>{
        return service.request("/battswap/app/service/openlog/info","post",data)
    },
    // 创建订单
    addOrder:(data)=>{
        return service.request("/battswap/app/order/add","post",data)
    },
    // 订单支付
    payOrder:(data)=>{
        return service.request("/battswap/app/order/pay","post",data)
    },
    // 订单购买记录
    getOrderList:(data)=>{
        return service.request("/battswap/app/order/paylog","post",data)
    },
    // 订单详情
    getOrderInfo:(data)=>{
        return service.request("/battswap/app/order/info","post",data)
    },
    // 用户账单详情
    getBillInfo:(data)=>{
        return service.request("/battswap/app/order/bill/info","post",data)
    },
    // 用户历史账单列表
    getBillList:(data)=>{
        return service.request("/battswap/app/order/bill/list","post",data)
    },
    // 用户当前账单
    getbillCurr:(data)=>{
        return service.request("/battswap/app/order/bill/curr","post",data)
    },
    // 用户未出账账单
    getbillUnsettle:(data)=>{
        return service.request("/battswap/app/order/bill/unsettle","post",data)
    },
    // 用户信息
    getUserInfo:(data)=>{
        return service.request("/battswap/app/user/info","post",data)
    },
}

export default server


// WEBPACK FOOTER //
// ./src/axios/api.js